import { BoxContainer } from '@/components';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { JSX } from 'react';
import { ServiceAdvantagesInner } from './ServiceAdvantagesInner/ServiceAdvantagesInner';
import styles from './styles.module.scss';

export type ServiceAdvantagesProps =
  SliceComponentProps<Content.ServiceAdvantagesSlice>;

const ServiceAdvantages = ({ slice }: ServiceAdvantagesProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <BoxContainer styles={styles.box_container}>
        <ServiceAdvantagesInner data={slice.primary} />
      </BoxContainer>
    </section>
  );
};

export default ServiceAdvantages;
